<template>
  <v-card class="edit supervisor elevation-4" dark v-if="experience">
    <can :I="isNew ? 'create' : 'update'" a="Supervisor">
      <v-card-title primary-title v-if="experience.organization">
        <v-avatar v-if="experience.organization.logo" class="mr-3">
          <v-img :src="experience.organization.logo" />
        </v-avatar>
        <div>
          <div class="headline">{{ supervisor.position || 'New Supervisor' }}</div>
          <span class="subheading grey--text">
            {{ experience.organization.name }}
          </span>
        </div>
      </v-card-title>

      <v-alert color="error" transition="scale-transition" :value="supervisor.errors">
        <ul>
          <li v-for="message in supervisor.errors" :key="message">{{ message }}</li>
        </ul>
      </v-alert>

      <v-divider />

      <v-form v-model="valid" @submit.prevent="save">
        <v-card-text>
          <v-text-field label="Name" v-model="supervisor.name" :rules="rules.name" counter="128" />

          <v-text-field
            label="Position"
            v-model="supervisor.position"
            :rules="rules.position"
            counter="64"
          />

          <v-text-field label="Email" v-model="supervisor.email" :rules="rules.email" />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn flat color="grey" @click="$emit('cancel')">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="!valid" @click="save">
            {{ isNew ? 'Create Supervisor' : 'Update Supervisor' }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </can>
  </v-card>
</template>

<script>
// Vue Component
export default {
  props: { experience: { type: Object, required: true }, supervisor: Object },
  data() {
    return {
      // Validations
      valid: true,
      rules: {
        name: [
          v => !!v || 'must be provided',
          v => v.length <= 128 || 'may not exceed 128 characters',
        ],
        position: [
          v => !!v || 'must be provided',
          v => v.length <= 64 || 'may not exceed 64 characters',
        ],
        email: [v => !!v || 'must be provided'],
      },
    }
  },
  computed: {
    isNew() {
      return !this.supervisor.id
    },
  },
  methods: {
    save() {
      if (this.valid) {
        if (this.isNew) {
          this.$store
            .dispatch('admin/supervisors/create', {
              supervisor: this.supervisor,
              experienceId: this.experience.id,
            })
            .then(() => {
              if (!this.supervisor.errors) this.$emit('cancel')
            })
        } else {
          this.$store
            .dispatch('admin/supervisors/update', {
              supervisor: this.supervisor,
              experienceId: this.experience.id,
            })
            .then(() => {
              if (!this.supervisor.errors) this.$emit('cancel')
            })
        }
      }
    },
  },
}
</script>
